import { Modal, Card, Image, Button, Col, Input, List, Spin, Upload, message, Form, Tabs, ConfigProvider } from 'antd';
import React__default, { createContext, useContext, useEffect, forwardRef, createElement, useState, useRef, useCallback } from 'react';
import styled from 'styled-components';
import ReactPlayer from 'react-player';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import 'react-image-crop/dist/ReactCrop.css';
import ReactCrop from 'react-image-crop';
import { pdfjs, Document, Page } from 'react-pdf';
import mime from 'mime-types';
import enUS from 'antd/lib/locale/en_US';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject;

var GalleryVideoWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  .ant-card-bordered {\n    width: 240px;\n  }\n"])));

var _templateObject$1, _templateObject2;

var StyledGalleryImage = styled.img(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n  object-fit: cover;\n"])));
var GalleryImageWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  .ant-card-bordered {\n    width: 240px;\n  }\n"])));

var _templateObject$2;

var GalleryDocumentWrapper = styled.div(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteralLoose(["\n  .ant-card-cover > * {\n    display: flex;\n    justify-content: center;\n  }\n  .ant-card-bordered {\n    width: 240px;\n  }\n"])));

var _templateObject$3, _templateObject2$1, _templateObject3, _templateObject4;

var GalleryPdfWrapper = styled.div(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteralLoose(["\n  .ant-card-cover > * {\n    display: flex;\n    justify-content: center;\n  }\n  .ant-card-bordered {\n    width: 240px;\n  }\n"])));
var PdfPreviewWrapper = styled(Modal)(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteralLoose(["\n  .react-pdf__Page {\n    display: flex;\n    justify-content: center;\n  }\n  .react-pdf__Page__canvas {\n    max-width: 450px;\n    max-height: 500px;\n    height: unset;\n    margin-top: 20px;\n    box-shadow: 0px 5px 5px grey;\n    border-radius: 10px;\n  }\n"])));
var PdfMetaOptions = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  margin-top: 10px;\n  font-size: 20px;\n"])));
var PagesWord = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  padding-left: 10px;\n  padding-right: 10px;\n"])));

var _templateObject$4, _templateObject2$2, _templateObject3$1;

var FileFieldModalWrapper = styled(Modal)(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteralLoose(["\n  .ant-btn-primary {\n    border-color: ", ";\n    background: ", ";\n  }\n  .ant-modal-body {\n    overflow-y: scroll;\n    max-height: 70vh;\n    position: relative;\n  }\n  .ant-modal {\n    min-width: 70vw;\n  }\n"])), function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.primary;
});
var MediaPaginationWrapper = styled.div(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteralLoose(["\nposition: sticky;\nbottom: -24px;\ndisplay: flex;\njustify-content: center;\npadding: 10px 0px;\nwidth: 100%;\nbackground-color: white ;\n\n\n\n"])));
var TabsWrapper = styled.div(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteralLoose(["\n  .ant-tabs-nav-list {\n    width: 100%;\n  }\n  .ant-tabs-tab {\n    width: 50%;\n    justify-content:center;\n  }\n  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n    color: ", ";\n  }\n\n  .ant-tabs-ink-bar {\n    background: ", ";\n  }\n"])), function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.primary;
});

var _templateObject$5;

var DraggerWrapper = styled.div(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteralLoose(["\n  .ant-upload.ant-upload-drag {\n    align-items: center;\n    justify-content: center;\n    display: flex;\n  }\n"])));

var _templateObject$6, _templateObject2$3, _templateObject3$2;

var ModalCropWrapper = styled.div(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n"])));
var ModalCropHeader = styled.div(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteralLoose(["\n  font-weight: 500;\n  margin-bottom: 10px;\n"])));
var CropComponentWrapper = styled.div(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteralLoose(["\n  border: 1px dashed black;\n  margin-bottom: 10px;\n  padding: 5px;\n  width: fit-content;\n  text-align: center;\n  .ReactCrop {\n    display: block;\n    width: fit-content;\n  }\n"])));

var _templateObject$7;

var GallerySearchWrapper = styled.div(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteralLoose(["\n  margin-bottom: 10px;\n"])));

var _templateObject$8, _templateObject2$4, _templateObject3$3, _templateObject4$1, _templateObject5;

var FileIconWrapper = styled.div(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteralLoose(["\n  font-size: 60px;\n  margin-top: 10px;\n"])));
var ImagePreviewWrapper = styled.div(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteralLoose(["\n  margin-top: 10px;\n  .ant-image {\n    text-align: center;\n  }\n  .ant-image-img {\n    object-fit: cover;\n  }\n"])));
var PreviewFileWrapper = styled.div(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteralLoose(["\n  box-shadow: 0px 0px 2px grey;\n  border-radius: 10px;\n  padding: 5px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n"])));
var FileNameWrapper = styled.div(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteralLoose(["\n  margin-left: 10px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])));
var DeleteButtonWrapper = styled.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n"])));
var IconContext = /*#__PURE__*/createContext({});

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var classnames = createCommonjsModule(function (module) {
  /*!
    Copyright (c) 2018 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */

  /* global define */
  (function () {
    var hasOwn = {}.hasOwnProperty;

    function classNames() {
      var classes = [];

      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;
        var argType = typeof arg;

        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg)) {
          if (arg.length) {
            var inner = classNames.apply(null, arg);

            if (inner) {
              classes.push(inner);
            }
          }
        } else if (argType === 'object') {
          if (arg.toString === Object.prototype.toString) {
            for (var key in arg) {
              if (hasOwn.call(arg, key) && arg[key]) {
                classes.push(key);
              }
            }
          } else {
            classes.push(arg.toString());
          }
        }
      }

      return classes.join(' ');
    }

    if (module.exports) {
      classNames.default = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
});

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
/**
 * Take input from [0, n] and return it as [0, 1]
 * @hidden
 */


function bound01(n, max) {
  if (isOnePointZero(n)) {
    n = '100%';
  }

  var isPercent = isPercentage(n);
  n = max === 360 ? n : Math.min(max, Math.max(0, parseFloat(n))); // Automatically convert percentage into number

  if (isPercent) {
    n = parseInt(String(n * max), 10) / 100;
  } // Handle floating point rounding errors


  if (Math.abs(n - max) < 0.000001) {
    return 1;
  } // Convert into [0, 1] range if it isn't already


  if (max === 360) {
    // If n is a hue given in degrees,
    // wrap around out-of-range values into [0, 360] range
    // then convert into [0, 1].
    n = (n < 0 ? n % max + max : n % max) / parseFloat(String(max));
  } else {
    // If n not a hue given in degrees
    // Convert into [0, 1] range if it isn't already.
    n = n % max / parseFloat(String(max));
  }

  return n;
}
/**
 * Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
 * <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
 * @hidden
 */


function isOnePointZero(n) {
  return typeof n === 'string' && n.indexOf('.') !== -1 && parseFloat(n) === 1;
}
/**
 * Check to see if string passed in is a percentage
 * @hidden
 */


function isPercentage(n) {
  return typeof n === 'string' && n.indexOf('%') !== -1;
}
/**
 * Return a valid alpha value [0,1] with all invalid values being set to 1
 * @hidden
 */


function boundAlpha(a) {
  a = parseFloat(a);

  if (isNaN(a) || a < 0 || a > 1) {
    a = 1;
  }

  return a;
}
/**
 * Replace a decimal with it's percentage value
 * @hidden
 */


function convertToPercentage(n) {
  if (n <= 1) {
    return Number(n) * 100 + "%";
  }

  return n;
}
/**
 * Force a hex value to have 2 characters
 * @hidden
 */


function pad2(c) {
  return c.length === 1 ? '0' + c : String(c);
} // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

/**
 * Handle bounds / percentage checking to conform to CSS color spec
 * <http://www.w3.org/TR/css3-color/>
 * *Assumes:* r, g, b in [0, 255] or [0, 1]
 * *Returns:* { r, g, b } in [0, 255]
 */


function rgbToRgb(r, g, b) {
  return {
    r: bound01(r, 255) * 255,
    g: bound01(g, 255) * 255,
    b: bound01(b, 255) * 255
  };
}

function hue2rgb(p, q, t) {
  if (t < 0) {
    t += 1;
  }

  if (t > 1) {
    t -= 1;
  }

  if (t < 1 / 6) {
    return p + (q - p) * (6 * t);
  }

  if (t < 1 / 2) {
    return q;
  }

  if (t < 2 / 3) {
    return p + (q - p) * (2 / 3 - t) * 6;
  }

  return p;
}
/**
 * Converts an HSL color value to RGB.
 *
 * *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
 * *Returns:* { r, g, b } in the set [0, 255]
 */


function hslToRgb(h, s, l) {
  var r;
  var g;
  var b;
  h = bound01(h, 360);
  s = bound01(s, 100);
  l = bound01(l, 100);

  if (s === 0) {
    // achromatic
    g = l;
    b = l;
    r = l;
  } else {
    var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    var p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }

  return {
    r: r * 255,
    g: g * 255,
    b: b * 255
  };
}
/**
 * Converts an RGB color value to HSV
 *
 * *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
 * *Returns:* { h, s, v } in [0,1]
 */


function rgbToHsv(r, g, b) {
  r = bound01(r, 255);
  g = bound01(g, 255);
  b = bound01(b, 255);
  var max = Math.max(r, g, b);
  var min = Math.min(r, g, b);
  var h = 0;
  var v = max;
  var d = max - min;
  var s = max === 0 ? 0 : d / max;

  if (max === min) {
    h = 0; // achromatic
  } else {
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;

      case g:
        h = (b - r) / d + 2;
        break;

      case b:
        h = (r - g) / d + 4;
        break;
    }

    h /= 6;
  }

  return {
    h: h,
    s: s,
    v: v
  };
}
/**
 * Converts an HSV color value to RGB.
 *
 * *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
 * *Returns:* { r, g, b } in the set [0, 255]
 */


function hsvToRgb(h, s, v) {
  h = bound01(h, 360) * 6;
  s = bound01(s, 100);
  v = bound01(v, 100);
  var i = Math.floor(h);
  var f = h - i;
  var p = v * (1 - s);
  var q = v * (1 - f * s);
  var t = v * (1 - (1 - f) * s);
  var mod = i % 6;
  var r = [v, q, p, p, t, v][mod];
  var g = [t, v, v, q, p, p][mod];
  var b = [p, p, t, v, v, q][mod];
  return {
    r: r * 255,
    g: g * 255,
    b: b * 255
  };
}
/**
 * Converts an RGB color to hex
 *
 * Assumes r, g, and b are contained in the set [0, 255]
 * Returns a 3 or 6 character hex
 */


function rgbToHex(r, g, b, allow3Char) {
  var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))]; // Return a 3 character hex if possible

  if (allow3Char && hex[0].startsWith(hex[0].charAt(1)) && hex[1].startsWith(hex[1].charAt(1)) && hex[2].startsWith(hex[2].charAt(1))) {
    return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
  }

  return hex.join('');
}
/** Converts a hex value to a decimal */


function convertHexToDecimal(h) {
  return parseIntFromHex(h) / 255;
}
/** Parse a base-16 hex value into a base-10 integer */


function parseIntFromHex(val) {
  return parseInt(val, 16);
} // https://github.com/bahamas10/css-color-names/blob/master/css-color-names.json

/**
 * @hidden
 */


var names = {
  aliceblue: '#f0f8ff',
  antiquewhite: '#faebd7',
  aqua: '#00ffff',
  aquamarine: '#7fffd4',
  azure: '#f0ffff',
  beige: '#f5f5dc',
  bisque: '#ffe4c4',
  black: '#000000',
  blanchedalmond: '#ffebcd',
  blue: '#0000ff',
  blueviolet: '#8a2be2',
  brown: '#a52a2a',
  burlywood: '#deb887',
  cadetblue: '#5f9ea0',
  chartreuse: '#7fff00',
  chocolate: '#d2691e',
  coral: '#ff7f50',
  cornflowerblue: '#6495ed',
  cornsilk: '#fff8dc',
  crimson: '#dc143c',
  cyan: '#00ffff',
  darkblue: '#00008b',
  darkcyan: '#008b8b',
  darkgoldenrod: '#b8860b',
  darkgray: '#a9a9a9',
  darkgreen: '#006400',
  darkgrey: '#a9a9a9',
  darkkhaki: '#bdb76b',
  darkmagenta: '#8b008b',
  darkolivegreen: '#556b2f',
  darkorange: '#ff8c00',
  darkorchid: '#9932cc',
  darkred: '#8b0000',
  darksalmon: '#e9967a',
  darkseagreen: '#8fbc8f',
  darkslateblue: '#483d8b',
  darkslategray: '#2f4f4f',
  darkslategrey: '#2f4f4f',
  darkturquoise: '#00ced1',
  darkviolet: '#9400d3',
  deeppink: '#ff1493',
  deepskyblue: '#00bfff',
  dimgray: '#696969',
  dimgrey: '#696969',
  dodgerblue: '#1e90ff',
  firebrick: '#b22222',
  floralwhite: '#fffaf0',
  forestgreen: '#228b22',
  fuchsia: '#ff00ff',
  gainsboro: '#dcdcdc',
  ghostwhite: '#f8f8ff',
  goldenrod: '#daa520',
  gold: '#ffd700',
  gray: '#808080',
  green: '#008000',
  greenyellow: '#adff2f',
  grey: '#808080',
  honeydew: '#f0fff0',
  hotpink: '#ff69b4',
  indianred: '#cd5c5c',
  indigo: '#4b0082',
  ivory: '#fffff0',
  khaki: '#f0e68c',
  lavenderblush: '#fff0f5',
  lavender: '#e6e6fa',
  lawngreen: '#7cfc00',
  lemonchiffon: '#fffacd',
  lightblue: '#add8e6',
  lightcoral: '#f08080',
  lightcyan: '#e0ffff',
  lightgoldenrodyellow: '#fafad2',
  lightgray: '#d3d3d3',
  lightgreen: '#90ee90',
  lightgrey: '#d3d3d3',
  lightpink: '#ffb6c1',
  lightsalmon: '#ffa07a',
  lightseagreen: '#20b2aa',
  lightskyblue: '#87cefa',
  lightslategray: '#778899',
  lightslategrey: '#778899',
  lightsteelblue: '#b0c4de',
  lightyellow: '#ffffe0',
  lime: '#00ff00',
  limegreen: '#32cd32',
  linen: '#faf0e6',
  magenta: '#ff00ff',
  maroon: '#800000',
  mediumaquamarine: '#66cdaa',
  mediumblue: '#0000cd',
  mediumorchid: '#ba55d3',
  mediumpurple: '#9370db',
  mediumseagreen: '#3cb371',
  mediumslateblue: '#7b68ee',
  mediumspringgreen: '#00fa9a',
  mediumturquoise: '#48d1cc',
  mediumvioletred: '#c71585',
  midnightblue: '#191970',
  mintcream: '#f5fffa',
  mistyrose: '#ffe4e1',
  moccasin: '#ffe4b5',
  navajowhite: '#ffdead',
  navy: '#000080',
  oldlace: '#fdf5e6',
  olive: '#808000',
  olivedrab: '#6b8e23',
  orange: '#ffa500',
  orangered: '#ff4500',
  orchid: '#da70d6',
  palegoldenrod: '#eee8aa',
  palegreen: '#98fb98',
  paleturquoise: '#afeeee',
  palevioletred: '#db7093',
  papayawhip: '#ffefd5',
  peachpuff: '#ffdab9',
  peru: '#cd853f',
  pink: '#ffc0cb',
  plum: '#dda0dd',
  powderblue: '#b0e0e6',
  purple: '#800080',
  rebeccapurple: '#663399',
  red: '#ff0000',
  rosybrown: '#bc8f8f',
  royalblue: '#4169e1',
  saddlebrown: '#8b4513',
  salmon: '#fa8072',
  sandybrown: '#f4a460',
  seagreen: '#2e8b57',
  seashell: '#fff5ee',
  sienna: '#a0522d',
  silver: '#c0c0c0',
  skyblue: '#87ceeb',
  slateblue: '#6a5acd',
  slategray: '#708090',
  slategrey: '#708090',
  snow: '#fffafa',
  springgreen: '#00ff7f',
  steelblue: '#4682b4',
  tan: '#d2b48c',
  teal: '#008080',
  thistle: '#d8bfd8',
  tomato: '#ff6347',
  turquoise: '#40e0d0',
  violet: '#ee82ee',
  wheat: '#f5deb3',
  white: '#ffffff',
  whitesmoke: '#f5f5f5',
  yellow: '#ffff00',
  yellowgreen: '#9acd32'
};
/**
 * Given a string or object, convert that input to RGB
 *
 * Possible string inputs:
 * ```
 * "red"
 * "#f00" or "f00"
 * "#ff0000" or "ff0000"
 * "#ff000000" or "ff000000"
 * "rgb 255 0 0" or "rgb (255, 0, 0)"
 * "rgb 1.0 0 0" or "rgb (1, 0, 0)"
 * "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
 * "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
 * "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
 * "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
 * "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
 * ```
 */

function inputToRGB(color) {
  var rgb = {
    r: 0,
    g: 0,
    b: 0
  };
  var a = 1;
  var s = null;
  var v = null;
  var l = null;
  var ok = false;
  var format = false;

  if (typeof color === 'string') {
    color = stringInputToObject(color);
  }

  if (typeof color === 'object') {
    if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
      rgb = rgbToRgb(color.r, color.g, color.b);
      ok = true;
      format = String(color.r).substr(-1) === '%' ? 'prgb' : 'rgb';
    } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
      s = convertToPercentage(color.s);
      v = convertToPercentage(color.v);
      rgb = hsvToRgb(color.h, s, v);
      ok = true;
      format = 'hsv';
    } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
      s = convertToPercentage(color.s);
      l = convertToPercentage(color.l);
      rgb = hslToRgb(color.h, s, l);
      ok = true;
      format = 'hsl';
    }

    if (Object.prototype.hasOwnProperty.call(color, 'a')) {
      a = color.a;
    }
  }

  a = boundAlpha(a);
  return {
    ok: ok,
    format: color.format || format,
    r: Math.min(255, Math.max(rgb.r, 0)),
    g: Math.min(255, Math.max(rgb.g, 0)),
    b: Math.min(255, Math.max(rgb.b, 0)),
    a: a
  };
} // <http://www.w3.org/TR/css3-values/#integers>


var CSS_INTEGER = '[-\\+]?\\d+%?'; // <http://www.w3.org/TR/css3-values/#number-value>

var CSS_NUMBER = '[-\\+]?\\d*\\.\\d+%?'; // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.

var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")"; // Actual matching.
// Parentheses and commas are optional, but not required.
// Whitespace can take the place of commas or opening paren

var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
var matchers = {
  CSS_UNIT: new RegExp(CSS_UNIT),
  rgb: new RegExp('rgb' + PERMISSIVE_MATCH3),
  rgba: new RegExp('rgba' + PERMISSIVE_MATCH4),
  hsl: new RegExp('hsl' + PERMISSIVE_MATCH3),
  hsla: new RegExp('hsla' + PERMISSIVE_MATCH4),
  hsv: new RegExp('hsv' + PERMISSIVE_MATCH3),
  hsva: new RegExp('hsva' + PERMISSIVE_MATCH4),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
/**
 * Permissive string parsing.  Take in a number of formats, and output an object
 * based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
 */

function stringInputToObject(color) {
  color = color.trim().toLowerCase();

  if (color.length === 0) {
    return false;
  }

  var named = false;

  if (names[color]) {
    color = names[color];
    named = true;
  } else if (color === 'transparent') {
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0,
      format: 'name'
    };
  } // Try to match string input using regular expressions.
  // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
  // Just return an object and let the conversion functions handle that.
  // This way the result will be the same whether the tinycolor is initialized with string or object.


  var match = matchers.rgb.exec(color);

  if (match) {
    return {
      r: match[1],
      g: match[2],
      b: match[3]
    };
  }

  match = matchers.rgba.exec(color);

  if (match) {
    return {
      r: match[1],
      g: match[2],
      b: match[3],
      a: match[4]
    };
  }

  match = matchers.hsl.exec(color);

  if (match) {
    return {
      h: match[1],
      s: match[2],
      l: match[3]
    };
  }

  match = matchers.hsla.exec(color);

  if (match) {
    return {
      h: match[1],
      s: match[2],
      l: match[3],
      a: match[4]
    };
  }

  match = matchers.hsv.exec(color);

  if (match) {
    return {
      h: match[1],
      s: match[2],
      v: match[3]
    };
  }

  match = matchers.hsva.exec(color);

  if (match) {
    return {
      h: match[1],
      s: match[2],
      v: match[3],
      a: match[4]
    };
  }

  match = matchers.hex8.exec(color);

  if (match) {
    return {
      r: parseIntFromHex(match[1]),
      g: parseIntFromHex(match[2]),
      b: parseIntFromHex(match[3]),
      a: convertHexToDecimal(match[4]),
      format: named ? 'name' : 'hex8'
    };
  }

  match = matchers.hex6.exec(color);

  if (match) {
    return {
      r: parseIntFromHex(match[1]),
      g: parseIntFromHex(match[2]),
      b: parseIntFromHex(match[3]),
      format: named ? 'name' : 'hex'
    };
  }

  match = matchers.hex4.exec(color);

  if (match) {
    return {
      r: parseIntFromHex(match[1] + match[1]),
      g: parseIntFromHex(match[2] + match[2]),
      b: parseIntFromHex(match[3] + match[3]),
      a: convertHexToDecimal(match[4] + match[4]),
      format: named ? 'name' : 'hex8'
    };
  }

  match = matchers.hex3.exec(color);

  if (match) {
    return {
      r: parseIntFromHex(match[1] + match[1]),
      g: parseIntFromHex(match[2] + match[2]),
      b: parseIntFromHex(match[3] + match[3]),
      format: named ? 'name' : 'hex'
    };
  }

  return false;
}
/**
 * Check to see if it looks like a CSS unit
 * (see `matchers` above for definition).
 */


function isValidCSSUnit(color) {
  return Boolean(matchers.CSS_UNIT.exec(String(color)));
}

var hueStep = 2; // 色相阶梯

var saturationStep = 0.16; // 饱和度阶梯，浅色部分

var saturationStep2 = 0.05; // 饱和度阶梯，深色部分

var brightnessStep1 = 0.05; // 亮度阶梯，浅色部分

var brightnessStep2 = 0.15; // 亮度阶梯，深色部分

var lightColorCount = 5; // 浅色数量，主色上

var darkColorCount = 4; // 深色数量，主色下
// 暗色主题颜色映射关系表

var darkColorMap = [{
  index: 7,
  opacity: 0.15
}, {
  index: 6,
  opacity: 0.25
}, {
  index: 5,
  opacity: 0.3
}, {
  index: 5,
  opacity: 0.45
}, {
  index: 5,
  opacity: 0.65
}, {
  index: 5,
  opacity: 0.85
}, {
  index: 4,
  opacity: 0.9
}, {
  index: 3,
  opacity: 0.95
}, {
  index: 2,
  opacity: 0.97
}, {
  index: 1,
  opacity: 0.98
}]; // Wrapper function ported from TinyColor.prototype.toHsv
// Keep it here because of `hsv.h * 360`

function toHsv(_ref) {
  var r = _ref.r,
      g = _ref.g,
      b = _ref.b;
  var hsv = rgbToHsv(r, g, b);
  return {
    h: hsv.h * 360,
    s: hsv.s,
    v: hsv.v
  };
} // Wrapper function ported from TinyColor.prototype.toHexString
// Keep it here because of the prefix `#`


function toHex(_ref2) {
  var r = _ref2.r,
      g = _ref2.g,
      b = _ref2.b;
  return "#".concat(rgbToHex(r, g, b, false));
} // Wrapper function ported from TinyColor.prototype.mix, not treeshakable.
// Amount in range [0, 1]
// Assume color1 & color2 has no alpha, since the following src code did so.


function mix(rgb1, rgb2, amount) {
  var p = amount / 100;
  var rgb = {
    r: (rgb2.r - rgb1.r) * p + rgb1.r,
    g: (rgb2.g - rgb1.g) * p + rgb1.g,
    b: (rgb2.b - rgb1.b) * p + rgb1.b
  };
  return rgb;
}

function getHue(hsv, i, light) {
  var hue; // 根据色相不同，色相转向不同

  if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) {
    hue = light ? Math.round(hsv.h) - hueStep * i : Math.round(hsv.h) + hueStep * i;
  } else {
    hue = light ? Math.round(hsv.h) + hueStep * i : Math.round(hsv.h) - hueStep * i;
  }

  if (hue < 0) {
    hue += 360;
  } else if (hue >= 360) {
    hue -= 360;
  }

  return hue;
}

function getSaturation(hsv, i, light) {
  // grey color don't change saturation
  if (hsv.h === 0 && hsv.s === 0) {
    return hsv.s;
  }

  var saturation;

  if (light) {
    saturation = hsv.s - saturationStep * i;
  } else if (i === darkColorCount) {
    saturation = hsv.s + saturationStep;
  } else {
    saturation = hsv.s + saturationStep2 * i;
  } // 边界值修正


  if (saturation > 1) {
    saturation = 1;
  } // 第一格的 s 限制在 0.06-0.1 之间


  if (light && i === lightColorCount && saturation > 0.1) {
    saturation = 0.1;
  }

  if (saturation < 0.06) {
    saturation = 0.06;
  }

  return Number(saturation.toFixed(2));
}

function getValue(hsv, i, light) {
  var value;

  if (light) {
    value = hsv.v + brightnessStep1 * i;
  } else {
    value = hsv.v - brightnessStep2 * i;
  }

  if (value > 1) {
    value = 1;
  }

  return Number(value.toFixed(2));
}

function generate(color) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var patterns = [];
  var pColor = inputToRGB(color);

  for (var i = lightColorCount; i > 0; i -= 1) {
    var hsv = toHsv(pColor);
    var colorString = toHex(inputToRGB({
      h: getHue(hsv, i, true),
      s: getSaturation(hsv, i, true),
      v: getValue(hsv, i, true)
    }));
    patterns.push(colorString);
  }

  patterns.push(toHex(pColor));

  for (var _i = 1; _i <= darkColorCount; _i += 1) {
    var _hsv = toHsv(pColor);

    var _colorString = toHex(inputToRGB({
      h: getHue(_hsv, _i),
      s: getSaturation(_hsv, _i),
      v: getValue(_hsv, _i)
    }));

    patterns.push(_colorString);
  } // dark theme patterns


  if (opts.theme === 'dark') {
    return darkColorMap.map(function (_ref3) {
      var index = _ref3.index,
          opacity = _ref3.opacity;
      var darkColorString = toHex(mix(inputToRGB(opts.backgroundColor || '#141414'), inputToRGB(patterns[index]), opacity * 100));
      return darkColorString;
    });
  }

  return patterns;
}

var presetPrimaryColors = {
  red: '#F5222D',
  volcano: '#FA541C',
  orange: '#FA8C16',
  gold: '#FAAD14',
  yellow: '#FADB14',
  lime: '#A0D911',
  green: '#52C41A',
  cyan: '#13C2C2',
  blue: '#1890FF',
  geekblue: '#2F54EB',
  purple: '#722ED1',
  magenta: '#EB2F96',
  grey: '#666666'
};
var presetPalettes = {};
var presetDarkPalettes = {};
Object.keys(presetPrimaryColors).forEach(function (key) {
  presetPalettes[key] = generate(presetPrimaryColors[key]);
  presetPalettes[key].primary = presetPalettes[key][5]; // dark presetPalettes

  presetDarkPalettes[key] = generate(presetPrimaryColors[key], {
    theme: 'dark',
    backgroundColor: '#141414'
  });
  presetDarkPalettes[key].primary = presetDarkPalettes[key][5];
});
/* eslint-disable no-console */

var warned = {};

function warning(valid, message) {
  // Support uglify
  if (process.env.NODE_ENV !== 'production' && !valid && console !== undefined) {
    console.error("Warning: ".concat(message));
  }
}

function call(method, valid, message) {
  if (!valid && !warned[message]) {
    method(false, message);
    warned[message] = true;
  }
}

function warningOnce(valid, message) {
  call(warning, valid, message);
}
/* eslint-enable */


function canUseDom() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}

var MARK_KEY = "rc-util-key";

function getMark() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      mark = _ref.mark;

  if (mark) {
    return mark.startsWith('data-') ? mark : "data-".concat(mark);
  }

  return MARK_KEY;
}

function getContainer(option) {
  if (option.attachTo) {
    return option.attachTo;
  }

  var head = document.querySelector('head');
  return head || document.body;
}

function injectCSS(css) {
  var _option$csp;

  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!canUseDom()) {
    return null;
  }

  var styleNode = document.createElement('style');

  if ((_option$csp = option.csp) === null || _option$csp === void 0 ? void 0 : _option$csp.nonce) {
    var _option$csp2;

    styleNode.nonce = (_option$csp2 = option.csp) === null || _option$csp2 === void 0 ? void 0 : _option$csp2.nonce;
  }

  styleNode.innerHTML = css;
  var container = getContainer(option);
  var firstChild = container.firstChild;

  if (option.prepend && container.prepend) {
    // Use `prepend` first
    container.prepend(styleNode);
  } else if (option.prepend && firstChild) {
    // Fallback to `insertBefore` like IE not support `prepend`
    container.insertBefore(styleNode, firstChild);
  } else {
    container.appendChild(styleNode);
  }

  return styleNode;
}

var containerCache = new Map();

function findExistNode(key) {
  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var container = getContainer(option);
  return Array.from(containerCache.get(container).children).find(function (node) {
    return node.tagName === 'STYLE' && node.getAttribute(getMark(option)) === key;
  });
}

function updateCSS(css, key) {
  var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var container = getContainer(option); // Get real parent

  if (!containerCache.has(container)) {
    var placeholderStyle = injectCSS('', option);
    var parentNode = placeholderStyle.parentNode;
    containerCache.set(container, parentNode);
    parentNode.removeChild(placeholderStyle);
  }

  var existNode = findExistNode(key, option);

  if (existNode) {
    var _option$csp3, _option$csp4;

    if (((_option$csp3 = option.csp) === null || _option$csp3 === void 0 ? void 0 : _option$csp3.nonce) && existNode.nonce !== ((_option$csp4 = option.csp) === null || _option$csp4 === void 0 ? void 0 : _option$csp4.nonce)) {
      var _option$csp5;

      existNode.nonce = (_option$csp5 = option.csp) === null || _option$csp5 === void 0 ? void 0 : _option$csp5.nonce;
    }

    if (existNode.innerHTML !== css) {
      existNode.innerHTML = css;
    }

    return existNode;
  }

  var newNode = injectCSS(css, option);
  newNode.setAttribute(getMark(option), key);
  return newNode;
}

function warning$1(valid, message) {
  warningOnce(valid, "[@ant-design/icons] ".concat(message));
}

function isIconDefinition(target) {
  return _typeof(target) === 'object' && typeof target.name === 'string' && typeof target.theme === 'string' && (_typeof(target.icon) === 'object' || typeof target.icon === 'function');
}

function normalizeAttrs() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.keys(attrs).reduce(function (acc, key) {
    var val = attrs[key];

    switch (key) {
      case 'class':
        acc.className = val;
        delete acc.class;
        break;

      default:
        acc[key] = val;
    }

    return acc;
  }, {});
}

function generate$1(node, key, rootProps) {
  if (!rootProps) {
    return /*#__PURE__*/React__default.createElement(node.tag, _objectSpread2({
      key: key
    }, normalizeAttrs(node.attrs)), (node.children || []).map(function (child, index) {
      return generate$1(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
  }

  return /*#__PURE__*/React__default.createElement(node.tag, _objectSpread2(_objectSpread2({
    key: key
  }, normalizeAttrs(node.attrs)), rootProps), (node.children || []).map(function (child, index) {
    return generate$1(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
  }));
}

function getSecondaryColor(primaryColor) {
  // choose the second color
  return generate(primaryColor)[0];
}

function normalizeTwoToneColors(twoToneColor) {
  if (!twoToneColor) {
    return [];
  }

  return Array.isArray(twoToneColor) ? twoToneColor : [twoToneColor];
} // These props make sure that the SVG behaviours like general text.


var iconStyles = "\n.anticon {\n  display: inline-block;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.anticon > * {\n  line-height: 1;\n}\n\n.anticon svg {\n  display: inline-block;\n}\n\n.anticon::before {\n  display: none;\n}\n\n.anticon .anticon-icon {\n  display: block;\n}\n\n.anticon[tabindex] {\n  cursor: pointer;\n}\n\n.anticon-spin::before,\n.anticon-spin {\n  display: inline-block;\n  -webkit-animation: loadingCircle 1s infinite linear;\n  animation: loadingCircle 1s infinite linear;\n}\n\n@-webkit-keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n";

var useInsertStyles = function useInsertStyles() {
  var styleStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : iconStyles;

  var _useContext = useContext(IconContext),
      csp = _useContext.csp;

  useEffect(function () {
    updateCSS(styleStr, '@ant-design-icons', {
      prepend: true,
      csp: csp
    });
  }, []);
};

var _excluded = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"];
var twoToneColorPalette = {
  primaryColor: '#333',
  secondaryColor: '#E6E6E6',
  calculated: false
};

function setTwoToneColors(_ref) {
  var primaryColor = _ref.primaryColor,
      secondaryColor = _ref.secondaryColor;
  twoToneColorPalette.primaryColor = primaryColor;
  twoToneColorPalette.secondaryColor = secondaryColor || getSecondaryColor(primaryColor);
  twoToneColorPalette.calculated = !!secondaryColor;
}

function getTwoToneColors() {
  return _objectSpread2({}, twoToneColorPalette);
}

var IconBase = function IconBase(props) {
  var icon = props.icon,
      className = props.className,
      onClick = props.onClick,
      style = props.style,
      primaryColor = props.primaryColor,
      secondaryColor = props.secondaryColor,
      restProps = _objectWithoutProperties(props, _excluded);

  var colors = twoToneColorPalette;

  if (primaryColor) {
    colors = {
      primaryColor: primaryColor,
      secondaryColor: secondaryColor || getSecondaryColor(primaryColor)
    };
  }

  useInsertStyles();
  warning$1(isIconDefinition(icon), "icon should be icon definiton, but got ".concat(icon));

  if (!isIconDefinition(icon)) {
    return null;
  }

  var target = icon;

  if (target && typeof target.icon === 'function') {
    target = _objectSpread2(_objectSpread2({}, target), {}, {
      icon: target.icon(colors.primaryColor, colors.secondaryColor)
    });
  }

  return generate$1(target.icon, "svg-".concat(target.name), _objectSpread2({
    className: className,
    onClick: onClick,
    style: style,
    'data-icon': target.name,
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    'aria-hidden': 'true'
  }, restProps));
};

IconBase.displayName = 'IconReact';
IconBase.getTwoToneColors = getTwoToneColors;
IconBase.setTwoToneColors = setTwoToneColors;

function setTwoToneColor(twoToneColor) {
  var _normalizeTwoToneColo = normalizeTwoToneColors(twoToneColor),
      _normalizeTwoToneColo2 = _slicedToArray(_normalizeTwoToneColo, 2),
      primaryColor = _normalizeTwoToneColo2[0],
      secondaryColor = _normalizeTwoToneColo2[1];

  return IconBase.setTwoToneColors({
    primaryColor: primaryColor,
    secondaryColor: secondaryColor
  });
}

function getTwoToneColor() {
  var colors = IconBase.getTwoToneColors();

  if (!colors.calculated) {
    return colors.primaryColor;
  }

  return [colors.primaryColor, colors.secondaryColor];
}

var _excluded$1 = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"]; // should move it to antd main repo?

setTwoToneColor('#1890ff');
var Icon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _classNames;

  var className = props.className,
      icon = props.icon,
      spin = props.spin,
      rotate = props.rotate,
      tabIndex = props.tabIndex,
      onClick = props.onClick,
      twoToneColor = props.twoToneColor,
      restProps = _objectWithoutProperties(props, _excluded$1);

  var _React$useContext = useContext(IconContext),
      _React$useContext$pre = _React$useContext.prefixCls,
      prefixCls = _React$useContext$pre === void 0 ? 'anticon' : _React$useContext$pre;

  var classString = classnames(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(icon.name), !!icon.name), _defineProperty(_classNames, "".concat(prefixCls, "-spin"), !!spin || icon.name === 'loading'), _classNames), className);
  var iconTabIndex = tabIndex;

  if (iconTabIndex === undefined && onClick) {
    iconTabIndex = -1;
  }

  var svgStyle = rotate ? {
    msTransform: "rotate(".concat(rotate, "deg)"),
    transform: "rotate(".concat(rotate, "deg)")
  } : undefined;

  var _normalizeTwoToneColo = normalizeTwoToneColors(twoToneColor),
      _normalizeTwoToneColo2 = _slicedToArray(_normalizeTwoToneColo, 2),
      primaryColor = _normalizeTwoToneColo2[0],
      secondaryColor = _normalizeTwoToneColo2[1];

  return /*#__PURE__*/createElement("span", _objectSpread2(_objectSpread2({
    role: "img",
    "aria-label": icon.name
  }, restProps), {}, {
    ref: ref,
    tabIndex: iconTabIndex,
    onClick: onClick,
    className: classString
  }), /*#__PURE__*/createElement(IconBase, {
    icon: icon,
    primaryColor: primaryColor,
    secondaryColor: secondaryColor,
    style: svgStyle
  }));
});
Icon.displayName = 'AntdIcon';
Icon.getTwoToneColor = getTwoToneColor;
Icon.setTwoToneColor = setTwoToneColor; // This icon file is generated automatically.

var ArrowLeftOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M872 474H286.9l350.2-304c5.6-4.9 2.2-14-5.2-14h-88.5c-3.9 0-7.6 1.4-10.5 3.9L155 487.8a31.96 31.96 0 000 48.3L535.1 866c1.5 1.3 3.3 2 5.2 2h91.5c7.4 0 10.8-9.2 5.2-14L286.9 550H872c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
      }
    }]
  },
  "name": "arrow-left",
  "theme": "outlined"
};

var ArrowLeftOutlined$1 = function ArrowLeftOutlined$1(props, ref) {
  return /*#__PURE__*/createElement(Icon, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    icon: ArrowLeftOutlined
  }));
};

ArrowLeftOutlined$1.displayName = 'ArrowLeftOutlined';
var PreviousIcon = /*#__PURE__*/forwardRef(ArrowLeftOutlined$1); // This icon file is generated automatically.

var ArrowRightOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 000-48.4z"
      }
    }]
  },
  "name": "arrow-right",
  "theme": "outlined"
};

var ArrowRightOutlined$1 = function ArrowRightOutlined$1(props, ref) {
  return /*#__PURE__*/createElement(Icon, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    icon: ArrowRightOutlined
  }));
};

ArrowRightOutlined$1.displayName = 'ArrowRightOutlined';
var NextIcon = /*#__PURE__*/forwardRef(ArrowRightOutlined$1); // This icon file is generated automatically.

var DeleteOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z"
      }
    }]
  },
  "name": "delete",
  "theme": "outlined"
};

var DeleteOutlined$1 = function DeleteOutlined$1(props, ref) {
  return /*#__PURE__*/createElement(Icon, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    icon: DeleteOutlined
  }));
};

DeleteOutlined$1.displayName = 'DeleteOutlined';
var DeleteOutlined$2 = /*#__PURE__*/forwardRef(DeleteOutlined$1); // This icon file is generated automatically.

var DownloadOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M505.7 661a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z"
      }
    }]
  },
  "name": "download",
  "theme": "outlined"
};

var DownloadOutlined$1 = function DownloadOutlined$1(props, ref) {
  return /*#__PURE__*/createElement(Icon, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    icon: DownloadOutlined
  }));
};

DownloadOutlined$1.displayName = 'DownloadOutlined';
var DownloadOutlined$2 = /*#__PURE__*/forwardRef(DownloadOutlined$1); // This icon file is generated automatically.

var ExpandOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "defs",
      "attrs": {},
      "children": [{
        "tag": "style",
        "attrs": {}
      }]
    }, {
      "tag": "path",
      "attrs": {
        "d": "M342 88H120c-17.7 0-32 14.3-32 32v224c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V168h174c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16zm578 576h-48c-8.8 0-16 7.2-16 16v176H682c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h222c17.7 0 32-14.3 32-32V680c0-8.8-7.2-16-16-16zM342 856H168V680c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16v224c0 17.7 14.3 32 32 32h222c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16zM904 88H682c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h174v176c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V120c0-17.7-14.3-32-32-32z"
      }
    }]
  },
  "name": "expand",
  "theme": "outlined"
};

var ExpandOutlined$1 = function ExpandOutlined$1(props, ref) {
  return /*#__PURE__*/createElement(Icon, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    icon: ExpandOutlined
  }));
};

ExpandOutlined$1.displayName = 'ExpandOutlined';
var PreviewIcon = /*#__PURE__*/forwardRef(ExpandOutlined$1); // This icon file is generated automatically.

var EyeOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"
      }
    }]
  },
  "name": "eye",
  "theme": "outlined"
};

var EyeOutlined$1 = function EyeOutlined$1(props, ref) {
  return /*#__PURE__*/createElement(Icon, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    icon: EyeOutlined
  }));
};

EyeOutlined$1.displayName = 'EyeOutlined';
var PreviewIcon$1 = /*#__PURE__*/forwardRef(EyeOutlined$1); // This icon file is generated automatically.

var FileOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z"
      }
    }]
  },
  "name": "file",
  "theme": "outlined"
};

var FileOutlined$1 = function FileOutlined$1(props, ref) {
  return /*#__PURE__*/createElement(Icon, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    icon: FileOutlined
  }));
};

FileOutlined$1.displayName = 'FileOutlined';
var FileOutlined$2 = /*#__PURE__*/forwardRef(FileOutlined$1); // This icon file is generated automatically.

var InboxOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M885.2 446.3l-.2-.8-112.2-285.1c-5-16.1-19.9-27.2-36.8-27.2H281.2c-17 0-32.1 11.3-36.9 27.6L139.4 443l-.3.7-.2.8c-1.3 4.9-1.7 9.9-1 14.8-.1 1.6-.2 3.2-.2 4.8V830a60.9 60.9 0 0060.8 60.8h627.2c33.5 0 60.8-27.3 60.9-60.8V464.1c0-1.3 0-2.6-.1-3.7.4-4.9 0-9.6-1.3-14.1zm-295.8-43l-.3 15.7c-.8 44.9-31.8 75.1-77.1 75.1-22.1 0-41.1-7.1-54.8-20.6S436 441.2 435.6 419l-.3-15.7H229.5L309 210h399.2l81.7 193.3H589.4zm-375 76.8h157.3c24.3 57.1 76 90.8 140.4 90.8 33.7 0 65-9.4 90.3-27.2 22.2-15.6 39.5-37.4 50.7-63.6h156.5V814H214.4V480.1z"
      }
    }]
  },
  "name": "inbox",
  "theme": "outlined"
};

var InboxOutlined$1 = function InboxOutlined$1(props, ref) {
  return /*#__PURE__*/createElement(Icon, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    icon: InboxOutlined
  }));
};

InboxOutlined$1.displayName = 'InboxOutlined';
var InboxOutlined$2 = /*#__PURE__*/forwardRef(InboxOutlined$1); // This icon file is generated automatically.

var LoadingOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"
      }
    }]
  },
  "name": "loading",
  "theme": "outlined"
};

var LoadingOutlined$1 = function LoadingOutlined$1(props, ref) {
  return /*#__PURE__*/createElement(Icon, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    icon: LoadingOutlined
  }));
};

LoadingOutlined$1.displayName = 'LoadingOutlined';
var LoadingOutlined$2 = /*#__PURE__*/forwardRef(LoadingOutlined$1); // This icon file is generated automatically.

var PaperClipOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 00174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z"
      }
    }]
  },
  "name": "paper-clip",
  "theme": "outlined"
};

var PaperClipOutlined$1 = function PaperClipOutlined$1(props, ref) {
  return /*#__PURE__*/createElement(Icon, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    icon: PaperClipOutlined
  }));
};

PaperClipOutlined$1.displayName = 'PaperClipOutlined';
var PaperClipOutlined$2 = /*#__PURE__*/forwardRef(PaperClipOutlined$1);
var Meta = Card.Meta;

var ReusableCard = function ReusableCard(_ref) {
  var cover = _ref.cover,
      actions = _ref.actions,
      onClick = _ref.onClick,
      title = _ref.title;
  return /*#__PURE__*/React__default.createElement(Card, {
    hoverable: true,
    cover: cover,
    actions: actions,
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement(Meta, {
    title: title
  }));
};

var GalleryImage = function GalleryImage(_ref) {
  var item = _ref.item,
      onChange = _ref.onChange,
      cropImage = _ref.cropImage,
      field = _ref.field;

  var _useState = useState(false),
      previewImage = _useState[0],
      setPreviewImage = _useState[1];

  var _useMedia = useMedia({
    field: field
  }),
      handleDownloadFile = _useMedia.handleDownloadFile;

  var handleChooseImage = function handleChooseImage() {
    onChange({
      file_url: item.file_url,
      media_id: item.id,
      name: item.name
    });
  };

  var handleCropImage = function handleCropImage(e) {
    e.stopPropagation();
    cropImage({
      item: item
    });
  };

  var handlePreviewImage = function handlePreviewImage(e) {
    e.stopPropagation();
    setPreviewImage(true);
  };

  var renderPreviewImage = function renderPreviewImage() {
    return previewImage && /*#__PURE__*/React__default.createElement(Image, {
      src: item.file_url,
      width: 0,
      height: 0,
      preview: {
        visible: true,
        onVisibleChange: function onVisibleChange() {
          return setPreviewImage(false);
        }
      }
    });
  };

  var handleDownloadImage = function handleDownloadImage(e) {
    e.stopPropagation();
    handleDownloadFile(item);
  };

  return /*#__PURE__*/React__default.createElement(GalleryImageWrapper, null, renderPreviewImage(), /*#__PURE__*/React__default.createElement(ReusableCard, {
    actions: [/*#__PURE__*/React__default.createElement(PreviewIcon, {
      key: 1,
      onClick: handleCropImage
    }), /*#__PURE__*/React__default.createElement(PreviewIcon$1, {
      key: 2,
      onClick: handlePreviewImage
    }), /*#__PURE__*/React__default.createElement(DownloadOutlined$2, {
      key: 3,
      onClick: handleDownloadImage
    })],
    title: item.name,
    cover: /*#__PURE__*/React__default.createElement(StyledGalleryImage, {
      src: item.file_url,
      preview: false,
      width: 150,
      height: 150
    }),
    onClick: handleChooseImage
  }));
};

var GalleryDocument = function GalleryDocument(_ref) {
  var item = _ref.item,
      onChange = _ref.onChange;

  var handlePreviewDocument = function handlePreviewDocument(e) {
    e.stopPropagation();
    window.open(item.file_url);
  };

  var handleChooseFile = function handleChooseFile() {
    onChange({
      file_url: item.file_url,
      media_id: item.id,
      name: item.name
    });
  };

  return /*#__PURE__*/React__default.createElement(GalleryDocumentWrapper, null, /*#__PURE__*/React__default.createElement(ReusableCard, {
    actions: [/*#__PURE__*/React__default.createElement(PreviewIcon$1, {
      onClick: handlePreviewDocument
    })],
    title: item.name,
    cover: /*#__PURE__*/React__default.createElement(FileIconWrapper, null, /*#__PURE__*/React__default.createElement(FileOutlined$2, {
      width: "100%",
      height: "100%"
    })),
    onClick: handleChooseFile
  }));
};

var GalleryVideo = function GalleryVideo(_ref) {
  var item = _ref.item,
      onChange = _ref.onChange,
      field = _ref.field;

  var _useMedia = useMedia({
    field: field
  }),
      handleDownloadFile = _useMedia.handleDownloadFile;

  var handleChooseVideo = function handleChooseVideo(e) {
    onChange({
      file_url: item.file_url,
      media_id: item.id,
      name: item.name
    });
  };

  var handleDownloadVideo = function handleDownloadVideo(e) {
    e.stopPropagation();
    handleDownloadFile(item);
  };

  return /*#__PURE__*/React__default.createElement(GalleryVideoWrapper, null, /*#__PURE__*/React__default.createElement(ReusableCard, {
    actions: [/*#__PURE__*/React__default.createElement(DownloadOutlined$2, {
      key: 1,
      onClick: handleDownloadVideo
    })],
    title: item.name,
    cover: /*#__PURE__*/React__default.createElement(ReactPlayer, {
      url: item.file_url,
      controls: true,
      width: "100%",
      height: "100%"
    }),
    onClick: handleChooseVideo
  }));
};

var CropImage = function CropImage(_ref) {
  var fileChosen = _ref.fileChosen,
      binaryFile = _ref.binaryFile,
      setCroppedImage = _ref.setCroppedImage,
      aspectRatio = _ref.aspectRatio,
      locked = _ref.locked;

  var _useTranslation = useTranslation("generalMedia"),
      t = _useTranslation.t;

  var imgRef = useRef(null);

  var getAspectRatio = function getAspectRatio() {
    if (!aspectRatio) return 16 / 9;
    if (aspectRatio === "free") return undefined;
    return aspectRatio;
  };

  var _useState = useState({
    unit: "%",
    aspect: getAspectRatio(),
    x: 0,
    y: 0,
    width: 100
  }),
      crop = _useState[0],
      setCrop = _useState[1];

  var onLoad = function onLoad(img) {
    imgRef.current = img;
    imgRef.current.crossOrigin = "anonymous";
  };

  var prepareCanvas = function prepareCanvas(image) {
    var canvas = document.createElement("canvas");
    var scaleX = image.naturalWidth / image.width;
    var scaleY = image.naturalHeight / image.height;
    var cropHeight = crop.height || image.height;
    canvas.width = crop.width;
    canvas.height = cropHeight;
    var ctx = canvas.getContext("2d");
    var pixelRatio = window.devicePixelRatio;
    canvas.width = crop.width * pixelRatio;
    canvas.height = cropHeight * pixelRatio;
    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = "high";
    ctx.drawImage(image, crop.x * scaleX, crop.y * scaleY, crop.width * scaleX, cropHeight * scaleY, 0, 0, crop.width, cropHeight);
    return canvas;
  };

  var getCroppedImg = function getCroppedImg(image, fileName) {
    if (crop.width === 0) {
      return false;
    }

    var canvas = prepareCanvas(image);
    return new Promise(function (resolve, reject) {
      canvas.toBlob(function (blob) {
        blob.name = fileName;
        resolve(blob);
      }, "image/png", 1);
    });
  };

  var generateCroppedImage = function generateCroppedImage() {
    try {
      return Promise.resolve(getCroppedImg(imgRef.current, "new")).then(function (croppedImg) {
        if (!croppedImg) {
          setCroppedImage(fileChosen);
        } else {
          var file = new File([croppedImg], "untitled", {
            type: croppedImg.type
          });
          setCroppedImage(file);
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return /*#__PURE__*/React__default.createElement(ModalCropWrapper, null, /*#__PURE__*/React__default.createElement(ModalCropHeader, null, t("useSelector")), /*#__PURE__*/React__default.createElement(CropComponentWrapper, null, /*#__PURE__*/React__default.createElement(ReactCrop, {
    src: binaryFile,
    onImageLoaded: onLoad,
    crop: crop,
    onChange: function onChange(c) {
      return setCrop(c);
    },
    locked: locked
  })), /*#__PURE__*/React__default.createElement(Button, {
    onClick: function onClick() {
      return generateCroppedImage();
    }
  }, t("upload")));
};

pdfjs.GlobalWorkerOptions.workerSrc = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/" + pdfjs.version + "/pdf.worker.js";

var PdfPreviewer = function PdfPreviewer(_ref) {
  var file = _ref.file,
      visible = _ref.visible,
      handleClose = _ref.handleClose;

  var _useState = useState(null),
      numPages = _useState[0],
      setNumPages = _useState[1];

  var _useState2 = useState(1),
      pageNumber = _useState2[0],
      setPageNumber = _useState2[1];

  var onDocumentLoadSuccess = function onDocumentLoadSuccess(_ref2) {
    var numPages = _ref2.numPages;
    setNumPages(numPages);
  };

  var handleNextPage = function handleNextPage() {
    setPageNumber(pageNumber + 1);
  };

  var handlePreviousPage = function handlePreviousPage() {
    setPageNumber(pageNumber - 1);
  };

  return /*#__PURE__*/React__default.createElement(PdfPreviewWrapper, {
    visible: visible,
    onCancel: handleClose,
    footer: null
  }, /*#__PURE__*/React__default.createElement(Document, {
    file: file,
    onLoadSuccess: onDocumentLoadSuccess
  }, /*#__PURE__*/React__default.createElement(Page, {
    pageNumber: pageNumber
  })), /*#__PURE__*/React__default.createElement(PdfMetaOptions, null, /*#__PURE__*/React__default.createElement("span", null, pageNumber !== 1 && /*#__PURE__*/React__default.createElement(PreviousIcon, {
    onClick: handlePreviousPage
  })), /*#__PURE__*/React__default.createElement(PagesWord, null, "Page ", pageNumber), /*#__PURE__*/React__default.createElement("span", null, pageNumber !== numPages && /*#__PURE__*/React__default.createElement(NextIcon, {
    onClick: handleNextPage
  }))));
};

var GalleryPdf = function GalleryPdf(_ref) {
  var field = _ref.field,
      item = _ref.item,
      onChange = _ref.onChange;

  var _useState = useState(false),
      pdfPreviewerOpen = _useState[0],
      setPdfPreviewerOpen = _useState[1];

  var _useMedia = useMedia({
    field: field
  }),
      handleDownloadFile = _useMedia.handleDownloadFile;

  var handleOpenPreviewModal = function handleOpenPreviewModal(e) {
    e.stopPropagation();
    setPdfPreviewerOpen(true);
  };

  var handleClosePreviewModal = function handleClosePreviewModal() {
    setPdfPreviewerOpen(false);
  };

  var handleDownloadPdf = function handleDownloadPdf(e) {
    e.stopPropagation();
    handleDownloadFile(item);
  };

  var handleChoosePdf = function handleChoosePdf() {
    onChange({
      file_url: item.file_url,
      media_id: item.id,
      name: item.name
    });
  };

  return /*#__PURE__*/React__default.createElement(GalleryPdfWrapper, null, /*#__PURE__*/React__default.createElement(PdfPreviewer, {
    file: item.file_url,
    visible: pdfPreviewerOpen,
    handleClose: handleClosePreviewModal
  }), /*#__PURE__*/React__default.createElement(ReusableCard, {
    actions: [/*#__PURE__*/React__default.createElement(PreviewIcon, {
      key: 1,
      onClick: handleOpenPreviewModal
    }), /*#__PURE__*/React__default.createElement(DownloadOutlined$2, {
      key: 2,
      onClick: handleDownloadPdf
    })],
    title: item.name,
    cover: /*#__PURE__*/React__default.createElement(FileIconWrapper, null, /*#__PURE__*/React__default.createElement(FileOutlined$2, {
      width: "100%",
      height: "100%"
    })),
    onClick: handleChoosePdf
  }));
};

var GalleryModal = function GalleryModal(_ref) {
  var open = _ref.open,
      onClose = _ref.onClose,
      onChange = _ref.onChange,
      field = _ref.field,
      listType = _ref.listType,
      onChangeCroppedImage = _ref.onChangeCroppedImage,
      mediaOptions = _ref.mediaOptions,
      actions = _ref.actions,
      data = _ref.data,
      entity = _ref.entity;

  var _useTranslation = useTranslation("generalMedia"),
      t = _useTranslation.t;

  var dispatch = useDispatch();

  var _useState = useState(""),
      query = _useState[0],
      setQuery = _useState[1];

  var _useState2 = useState(false),
      crop = _useState2[0],
      setCrop = _useState2[1];

  var _useState3 = useState(),
      croppedImage = _useState3[0],
      setCroppedImage = _useState3[1];

  var dispatchRequest = useCallback(function (payload) {
    dispatch(actions.list.request(payload));
  }, [dispatch, entity.name]);

  var handleSearch = function handleSearch(e) {
    setQuery(e.target.value);
  };

  useEffect(function () {
    dispatchRequest({
      entity: entity,
      query: query,
      content_type: listType
    });
  }, [query, listType, open]);

  var handleClose = function handleClose() {
    setCrop(false);
    setCroppedImage();
    onClose();
  };

  var handleImageToCrop = function handleImageToCrop(_ref2) {
    var item = _ref2.item;
    setCroppedImage(item.file_url);
    setCrop(true);
  };

  var getContentType = function getContentType(item) {
    if (!Array.isArray(listType) && listType !== "media") return listType;
    var currentMimeType = mime.lookup(item.file_url) || item.content_type;

    if (!currentMimeType) {
      return "other";
    }

    var isVideo = currentMimeType === null || currentMimeType === void 0 ? void 0 : currentMimeType.includes("video");
    var isImage = currentMimeType === null || currentMimeType === void 0 ? void 0 : currentMimeType.includes("image");
    if (isVideo) return "video";
    if (isImage) return "image";
    return "other";
  };

  var renderMediaItem = function renderMediaItem(item) {
    var props = {
      field: field,
      item: item,
      onChange: onChange
    };
    var contentType = getContentType(item);

    switch (contentType) {
      case "image":
        return /*#__PURE__*/React__default.createElement(GalleryImage, _extends({
          cropImage: handleImageToCrop
        }, props));

      case "video":
        return /*#__PURE__*/React__default.createElement(GalleryVideo, props);

      case "pdf":
        return /*#__PURE__*/React__default.createElement(GalleryPdf, props);

      default:
        return /*#__PURE__*/React__default.createElement(GalleryDocument, props);
    }
  };

  var renderData = function renderData() {
    return /*#__PURE__*/React__default.createElement(List, {
      grid: {
        gutter: 16,
        xs: 1,
        sm: 2,
        md: 2,
        lg: 2,
        xl: 4,
        xxl: 5
      },
      dataSource: data,
      renderItem: function renderItem(item) {
        return /*#__PURE__*/React__default.createElement(List.Item, null, renderMediaItem(item));
      }
    });
  };

  var renderSearch = function renderSearch() {
    return /*#__PURE__*/React__default.createElement(GallerySearchWrapper, null, /*#__PURE__*/React__default.createElement(Col, {
      lg: 12,
      xs: 24
    }, /*#__PURE__*/React__default.createElement(Input.Search, {
      placeholder: t("search"),
      onChange: handleSearch
    })));
  };

  var handleNewImage = function handleNewImage(file) {
    onChangeCroppedImage(file);
    handleClose();
  };

  var renderCropImage = function renderCropImage() {
    return /*#__PURE__*/React__default.createElement(CropImage, _extends({
      binary: croppedImage,
      binaryFile: croppedImage,
      setCroppedImage: handleNewImage
    }, mediaOptions));
  };

  return /*#__PURE__*/React__default.createElement("div", null, crop ? /*#__PURE__*/React__default.createElement("div", null, renderCropImage()) : /*#__PURE__*/React__default.createElement("div", null, renderSearch(), renderData()));
};

var useMedia = function useMedia(_ref) {
  var onChange = _ref.onChange,
      setOpen = _ref.setOpen,
      listType = _ref.listType,
      initialFilePreview = _ref.filePreview,
      field = _ref.field,
      type = _ref.type;

  var _useState = useState(),
      fileChosen = _useState[0],
      setFileChosen = _useState[1];

  var _useState2 = useState(),
      fileName = _useState2[0],
      setFileName = _useState2[1];

  var _useState3 = useState(initialFilePreview),
      filePreview = _useState3[0],
      setFilePreview = _useState3[1];

  var allowedExtensions = field.getAllowedExtensions();
  var currentFile = fileChosen || filePreview;

  var accept = function accept() {
    if (allowedExtensions) return allowedExtensions;
    if (type === "pdf") return "application/pdf";
    if (type === "file") return "";
    return type + "/*";
  };

  var handleDownloadFile = function handleDownloadFile(item) {
    window.open(item.file_url);
  };

  var handleRemoveFile = function handleRemoveFile() {
    setFileChosen();
    setFileName();
    setFilePreview();
    onChange(field, undefined);
    onChange("media_id", undefined);
  };

  var renderDeleteButton = function renderDeleteButton() {
    return /*#__PURE__*/React__default.createElement(DeleteButtonWrapper, {
      onClick: handleRemoveFile
    }, /*#__PURE__*/React__default.createElement(DeleteOutlined$2, null));
  };

  var previewOtherFile = function previewOtherFile() {
    if (currentFile) {
      return /*#__PURE__*/React__default.createElement(PreviewFileWrapper, null, /*#__PURE__*/React__default.createElement(PaperClipOutlined$2, null), /*#__PURE__*/React__default.createElement(FileNameWrapper, null, fileName), renderDeleteButton());
    }
  };

  var previewImageFile = function previewImageFile() {
    if (currentFile) {
      return /*#__PURE__*/React__default.createElement(PreviewFileWrapper, null, /*#__PURE__*/React__default.createElement(Image, {
        preview: true,
        src: currentFile,
        width: 100,
        height: 100
      }), renderDeleteButton());
    }
  };

  var previewVideoFile = function previewVideoFile() {
    if (currentFile) {
      return /*#__PURE__*/React__default.createElement(PreviewFileWrapper, null, /*#__PURE__*/React__default.createElement(ReactPlayer, {
        url: currentFile,
        width: 100,
        height: 100,
        controls: true
      }), renderDeleteButton());
    }
  };

  var previewPdfFile = function previewPdfFile() {
    var _useState4 = useState(false),
        isPdfPreviewerOpen = _useState4[0],
        setPdfPreviewerOpen = _useState4[1];

    var handleOpenPreviewModal = function handleOpenPreviewModal(e) {
      e.stopPropagation();
      setPdfPreviewerOpen(true);
    };

    var handleClosePreviewModal = function handleClosePreviewModal() {
      setPdfPreviewerOpen(false);
    };

    if (currentFile) {
      return /*#__PURE__*/React__default.createElement(PreviewFileWrapper, null, /*#__PURE__*/React__default.createElement(PreviewIcon, {
        onClick: handleOpenPreviewModal
      }), /*#__PURE__*/React__default.createElement(PdfPreviewer, {
        file: fileChosen || filePreview,
        visible: isPdfPreviewerOpen,
        handleClose: handleClosePreviewModal
      }), /*#__PURE__*/React__default.createElement(FileNameWrapper, null, fileName || filePreview), renderDeleteButton());
    }
  };

  var handleMultiPreviewTypes = function handleMultiPreviewTypes() {
    if (currentFile instanceof File) {
      return previewOtherFile();
    }

    var currentMimeType = mime.lookup(currentFile);
    if (!currentMimeType) return previewImageFile();
    var isVideo = currentMimeType.includes("video");
    var isImage = currentMimeType.includes("image");
    if (isVideo) return previewTypes("video");
    if (isImage) return previewTypes("image");
    return previewOtherFile();
  };

  var previewTypes = function previewTypes(mimeType) {
    if (Array.isArray(listType) && !mimeType) return handleMultiPreviewTypes();

    switch (mimeType || listType) {
      case "image":
        return previewImageFile();

      case "video":
        return previewVideoFile();

      case "pdf":
        return previewPdfFile();

      case "other":
        return previewOtherFile();

      case "media":
        return handleMultiPreviewTypes();

      default:
        return previewOtherFile();
    }
  };

  var preview = function preview() {
    return /*#__PURE__*/React__default.createElement(ImagePreviewWrapper, null, previewTypes());
  };

  var handleOpenModal = function handleOpenModal() {
    setOpen(true);
  };

  var handleCloseModal = function handleCloseModal() {
    setOpen(false);
  };

  return {
    preview: preview,
    setFileChosen: setFileChosen,
    setFileName: setFileName,
    handleOpenModal: handleOpenModal,
    handleCloseModal: handleCloseModal,
    accept: accept,
    handleDownloadFile: handleDownloadFile
  };
};

var antIcon = /*#__PURE__*/React__default.createElement(LoadingOutlined$2, {
  spin: true
});

var SpinningLoader = function SpinningLoader(_ref) {
  var spinning = _ref.spinning,
      children = _ref.children;
  return /*#__PURE__*/React__default.createElement(Spin, {
    spinning: spinning,
    indicator: antIcon,
    size: "large"
  }, children);
};

var Dragger = Upload.Dragger;

var DragAndDrop = function DragAndDrop(_ref) {
  var type = _ref.type,
      handleUpload = _ref.handleUpload,
      field = _ref.field;

  var _useMedia = useMedia({
    field: field,
    type: type
  }),
      accept = _useMedia.accept;

  var _useTranslation = useTranslation("generalMedia"),
      t = _useTranslation.t;

  var _useState = useState(false),
      isUploading = _useState[0],
      setIsUploading = _useState[1];

  var props = {
    name: "file",
    multiple: false,
    showUploadList: false,
    accept: accept()
  };

  var onUpload = function onUpload(file) {
    message.success(file.name + " " + t("uploadedSuccess"));
    handleUpload(file);
  };

  return /*#__PURE__*/React__default.createElement(SpinningLoader, {
    spinning: isUploading
  }, /*#__PURE__*/React__default.createElement(DraggerWrapper, null, /*#__PURE__*/React__default.createElement(Dragger, _extends({}, props, {
    beforeUpload: function beforeUpload(file) {
      setIsUploading(true);
      onUpload(file);
      return false;
    }
  }), /*#__PURE__*/React__default.createElement("p", {
    className: "ant-upload-drag-icon"
  }, /*#__PURE__*/React__default.createElement(InboxOutlined$2, null)), /*#__PURE__*/React__default.createElement("p", {
    className: "ant-upload-text"
  }, t("dragFile")))));
};

var ChooseName = function ChooseName(_ref) {
  var onChange = _ref.onChange,
      file = _ref.file;

  var _useTranslation = useTranslation("generalMedia"),
      t = _useTranslation.t;

  var onFinish = function onFinish(props) {
    onChange({
      file: file,
      name: props.name
    });
  };

  return /*#__PURE__*/React__default.createElement(Form, {
    onFinish: onFinish
  }, /*#__PURE__*/React__default.createElement(Form.Item, {
    label: t("mediaName"),
    name: "name",
    rules: [{
      required: true,
      message: t("requiredFields")
    }]
  }, /*#__PURE__*/React__default.createElement(Input, {
    placeholder: t("placeHolderMediaName")
  })), /*#__PURE__*/React__default.createElement(Form.Item, null, /*#__PURE__*/React__default.createElement(Button, {
    type: "primary",
    htmlType: "submit"
  }, t("upload"))));
};

var ChooseExternal = function ChooseExternal(_ref) {
  var onChange = _ref.onChange;

  var _useTranslation = useTranslation("generalMedia"),
      t = _useTranslation.t;

  var onFinish = function onFinish(props) {
    onChange({
      file: props.external,
      isExternal: true
    });
  };

  return /*#__PURE__*/React__default.createElement(Form, {
    onFinish: onFinish
  }, /*#__PURE__*/React__default.createElement(Form.Item, {
    label: t("external"),
    name: "external",
    rules: [{
      required: true,
      message: t("requiredFields")
    }]
  }, /*#__PURE__*/React__default.createElement(Input, null)), /*#__PURE__*/React__default.createElement(Form.Item, null, /*#__PURE__*/React__default.createElement(Button, {
    type: "primary",
    htmlType: "submit"
  }, t("submit"))));
};

var useSelector = "Use the selector to adjust your image";
var upload = "Upload";
var search = "Search";
var fromGallery = "From gallery";
var placeHolderMediaName = "Example: Image for Product...";
var requiredFields = "This field is required";
var mediaName = "Add a name for this file";
var chooseFile = "Choose a file";
var dragFile = "Click or drag file to this area to upload";
var uploadedSuccess = "file uploaded successfuly";
var external = "External";
var submit = "Submit";
var en = {
  useSelector: useSelector,
  upload: upload,
  search: search,
  fromGallery: fromGallery,
  placeHolderMediaName: placeHolderMediaName,
  requiredFields: requiredFields,
  mediaName: mediaName,
  chooseFile: chooseFile,
  dragFile: dragFile,
  uploadedSuccess: uploadedSuccess,
  external: external,
  submit: submit
};
var useSelector$1 = "استخدم المنقار لتغير الصورة";
var upload$1 = "رفع";
var search$1 = "بحث";
var fromGallery$1 = "من معرض الصور";
var placeHolderMediaName$1 = "مثال: صورة للمنتج ...";
var requiredFields$1 = "هذه الخانة مطلوبه";
var mediaName$1 = "اضف اسم لهذا الملف";
var chooseFile$1 = "اختر ملف";
var dragFile$1 = "انقر أو اسحب الملف إلى هذه المنطقة للتحميل";
var uploadedSuccess$1 = "تم تحميل الملف بنجاح";
var external$1 = "خارجي";
var submit$1 = "ارسال";
var ar = {
  useSelector: useSelector$1,
  upload: upload$1,
  search: search$1,
  fromGallery: fromGallery$1,
  placeHolderMediaName: placeHolderMediaName$1,
  requiredFields: requiredFields$1,
  mediaName: mediaName$1,
  chooseFile: chooseFile$1,
  dragFile: dragFile$1,
  uploadedSuccess: uploadedSuccess$1,
  external: external$1,
  submit: submit$1
};

var useMediaChange = function useMediaChange(_ref) {
  var field = _ref.field,
      onChange = _ref.onChange,
      listType = _ref.listType,
      setFileChosen = _ref.setFileChosen,
      setOpen = _ref.setOpen,
      setFileName = _ref.setFileName;
  var extraWrapper = field.extraWrapper,
      sendObjectPayload = field.sendObjectPayload;

  var getBase64 = function getBase64(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = function () {
        return resolve(reader.result);
      };

      reader.onerror = function (error) {
        return reject(error);
      };
    });
  };

  var handleChangeNewFile = function handleChangeNewFile(file, name, isExternal) {
    try {
      setFileName(name);

      var constructObjectPayload = function constructObjectPayload() {
        if (isExternal) return file;
        return _extends({
          file: file,
          content_type: listType,
          media_id: ""
        }, name && {
          name: name
        });
      };

      var _temp3 = function () {
        if (file) {
          if (file.uid) delete file.uid;

          if (sendObjectPayload) {
            onChange(field, constructObjectPayload());
          } else {
            onChange("file", file, extraWrapper);
            onChange("content_type", listType, extraWrapper);
            onChange("media_id", "", extraWrapper);
            if (name) onChange("name", name, extraWrapper);
          }

          var _temp4 = function () {
            if (listType === "image" && !isExternal) {
              return Promise.resolve(getBase64(file)).then(function (preview) {
                setFileChosen(preview);
              });
            } else {
              setFileChosen(file);
            }
          }();

          if (_temp4 && _temp4.then) return _temp4.then(function () {});
        }
      }();

      return Promise.resolve(_temp3 && _temp3.then ? _temp3.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var handleChangeFileFromGallery = function handleChangeFileFromGallery(_ref2) {
    var file_url = _ref2.file_url,
        media_id = _ref2.media_id,
        name = _ref2.name;
    setFileChosen(file_url);
    setFileName(name);

    if (sendObjectPayload) {
      onChange(field, {
        file_url: file_url,
        media_id: media_id
      });
    } else {
      onChange(field, file_url);
      onChange("media_id", media_id);
    }

    setOpen(false);
  };

  return {
    handleChangeNewFile: handleChangeNewFile,
    handleChangeFileFromGallery: handleChangeFileFromGallery,
    getBase64: getBase64
  };
};

var TabPane = Tabs.TabPane;

var FileFieldModal = function FileFieldModal(_ref) {
  var field = _ref.field,
      type = _ref.type,
      _ref$listType = _ref.listType,
      listType = _ref$listType === void 0 ? "text" : _ref$listType,
      open = _ref.open,
      onChange = _ref.onChange,
      onClose = _ref.onClose,
      mediaOptions = _ref.mediaOptions,
      onChangeCroppedImage = _ref.onChangeCroppedImage,
      handleChangeFileFromGallery = _ref.handleChangeFileFromGallery,
      DataPagination = _ref.DataPagination,
      mediaEntity = _ref.mediaEntity,
      actions = _ref.actions,
      theme = _ref.theme,
      entity = _ref.entity,
      allowExternal = _ref.field.allowExternal;

  var _useMediaChange = useMediaChange({
    field: field
  }),
      getBase64 = _useMediaChange.getBase64;

  var _useTranslation = useTranslation("generalMedia"),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var _useState = useState(),
      fileChosen = _useState[0],
      setFileChosen = _useState[1];

  var _useState2 = useState(),
      fileChosenBinary = _useState2[0],
      setFileChosenBinary = _useState2[1];

  var currentPage = mediaEntity.currentPage,
      rowsPerPage = mediaEntity.rowsPerPage,
      totalEntries = mediaEntity.totalEntries,
      loading = mediaEntity.loading;

  var _useState3 = useState("choosing"),
      currentStep = _useState3[0],
      setCurrentStep = _useState3[1];

  var _useState4 = useState("1"),
      currentTab = _useState4[0],
      setCurrentTab = _useState4[1];

  var dispatch = useDispatch();
  useEffect(function () {
    i18n.addResources("en", "generalMedia", en);
    i18n.addResources("ar", "generalMedia", ar);
  }, []);
  var dispatchRequest = useCallback(function (payload) {
    dispatch(actions.list.request(payload));
  }, [dispatch, entity.name]);

  var handleClose = function handleClose() {
    setFileChosen();
    setCurrentStep("choosing");
    onClose();
  };

  var onPaginationChange = function onPaginationChange(page, rowsPerPage) {
    dispatchRequest({
      entity: entity,
      page: page,
      rowsPerPage: rowsPerPage
    });
  };

  var handleUpload = function handleUpload(file) {
    try {
      var _temp2 = function () {
        if (type !== "image") {
          closeWithCroppedImage(file);
        } else {
          return Promise.resolve(getBase64(file)).then(function (binary) {
            setFileChosenBinary(binary);
            setFileChosen(file);
            setCurrentStep("cropImage");
          });
        }
      }();

      return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var closeWithCroppedImage = function closeWithCroppedImage(file) {
    setFileChosen(file);
    setCurrentStep("chooseName");
  };

  var uploadNewImage = function uploadNewImage(_ref2) {
    var file = _ref2.file,
        _ref2$name = _ref2.name,
        name = _ref2$name === void 0 ? "untitled" : _ref2$name,
        _ref2$isExternal = _ref2.isExternal,
        isExternal = _ref2$isExternal === void 0 ? false : _ref2$isExternal;
    setFileChosen();
    onChange(file, name, isExternal);
    setCurrentStep("choosing");
    onClose();
  };

  var renderPagination = function renderPagination() {
    return /*#__PURE__*/React__default.createElement(MediaPaginationWrapper, null, /*#__PURE__*/React__default.createElement(DataPagination, {
      currentPage: currentPage,
      rowsPerPage: rowsPerPage,
      totalEntries: totalEntries,
      entityRowsPerPage: entity.rowsPerPage,
      onPaginationChange: onPaginationChange,
      isReduced: entity.isReducedPaginationMode()
    }));
  };

  var onTabClick = function onTabClick(tabKey) {
    setCurrentTab(tabKey);
  };

  var uploadSteps = {
    choosing: /*#__PURE__*/React__default.createElement(SpinningLoader, {
      spinning: loading
    }, /*#__PURE__*/React__default.createElement(TabsWrapper, {
      theme: theme
    }, /*#__PURE__*/React__default.createElement(Tabs, {
      onTabClick: onTabClick,
      defaultActiveKey: "1"
    }, /*#__PURE__*/React__default.createElement(TabPane, {
      tab: t("fromGallery"),
      key: "1"
    }, /*#__PURE__*/React__default.createElement(GalleryModal, {
      field: field,
      listType: listType,
      onChange: handleChangeFileFromGallery,
      onChangeCroppedImage: onChangeCroppedImage,
      mediaOptions: mediaOptions,
      onClose: handleClose,
      actions: actions,
      data: mediaEntity === null || mediaEntity === void 0 ? void 0 : mediaEntity.data,
      entity: entity
    }), renderPagination()), /*#__PURE__*/React__default.createElement(TabPane, {
      tab: t("upload"),
      key: "2"
    }, /*#__PURE__*/React__default.createElement(DragAndDrop, {
      type: type,
      handleUpload: handleUpload,
      field: field
    })), allowExternal && /*#__PURE__*/React__default.createElement(TabPane, {
      tab: t("external"),
      key: "3"
    }, /*#__PURE__*/React__default.createElement(ChooseExternal, {
      onChange: uploadNewImage
    }))))),
    cropImage: /*#__PURE__*/React__default.createElement(CropImage, _extends({
      fileChosen: fileChosen,
      binaryFile: fileChosenBinary,
      setCroppedImage: closeWithCroppedImage
    }, mediaOptions)),
    chooseName: /*#__PURE__*/React__default.createElement(ChooseName, {
      onChange: uploadNewImage,
      file: fileChosen
    })
  };
  var isExternalTab = currentTab === "3";
  return /*#__PURE__*/React__default.createElement(FileFieldModalWrapper, _extends({
    title: t("chooseFile"),
    visible: open,
    onCancel: handleClose,
    centered: true,
    destroyOnClose: true,
    maskClosable: !fileChosen,
    theme: theme,
    style: {
      minWidth: "70vw"
    }
  }, (fileChosen || isExternalTab) && {
    footer: null
  }), uploadSteps[currentStep]);
};

var MediaEntry = function MediaEntry(_ref) {
  var field = _ref.field,
      type = _ref.type,
      _ref$listType = _ref.listType,
      listType = _ref$listType === void 0 ? "text" : _ref$listType,
      onChange = _ref.onChange,
      DataPagination = _ref.DataPagination,
      mediaEntity = _ref.mediaEntity,
      actions = _ref.actions,
      theme = _ref.theme,
      filePreview = _ref.filePreview,
      file = _ref.file,
      entity = _ref.entity;

  var _useState = useState(false),
      open = _useState[0],
      setOpen = _useState[1];

  var _useTranslation = useTranslation("generalMedia"),
      t = _useTranslation.t;

  var _useMedia = useMedia({
    field: field,
    onChange: onChange,
    setOpen: setOpen,
    listType: listType,
    type: type,
    filePreview: filePreview
  }),
      preview = _useMedia.preview,
      handleCloseModal = _useMedia.handleCloseModal,
      handleOpenModal = _useMedia.handleOpenModal,
      setFileChosen = _useMedia.setFileChosen,
      setFileName = _useMedia.setFileName;

  var _useMediaChange = useMediaChange({
    field: field,
    onChange: onChange,
    setOpen: setOpen,
    setFileChosen: setFileChosen,
    setFileName: setFileName,
    listType: listType
  }),
      handleChangeFileFromGallery = _useMediaChange.handleChangeFileFromGallery,
      handleChangeNewFile = _useMediaChange.handleChangeNewFile;

  return /*#__PURE__*/React__default.createElement(ConfigProvider, {
    locale: enUS
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Button, {
    icon: /*#__PURE__*/React__default.createElement(PaperClipOutlined$2, null),
    onClick: handleOpenModal
  }, file ? t("change") : t("choose"), " ", t("file")), preview(), /*#__PURE__*/React__default.createElement(FileFieldModal, {
    open: open,
    identifier: field.identifier,
    type: type,
    listType: listType,
    file: file,
    onClose: handleCloseModal,
    onChange: handleChangeNewFile,
    field: field,
    onChangeCroppedImage: handleChangeNewFile,
    handleChangeFileFromGallery: handleChangeFileFromGallery,
    mediaOptions: field.getMediaOptions(),
    mediaEntity: mediaEntity,
    DataPagination: DataPagination,
    actions: actions,
    theme: theme,
    entity: entity
  })));
};

var Media = {
  name: "media",
  pluralName: "media",
  pathName: "media",
  endpoint: "admins/media",
  serverName: "media",
  serverPluralName: "media",
  displayName: "Media",
  allowCreate: true,
  allowEdit: true,
  allowDelete: true,
  showRowActions: true,
  showSearch: true,
  titleField: "name",
  useFormData: true,
  entityIdentifier: "id",
  customNotifications: {
    "delete": {
      error: {
        title: "Error",
        message: function message(dataObject, language) {
          return dataObject.media[0];
        }
      }
    }
  },
  fields: [{
    identifier: "id",
    label: "ID",
    accessor: function accessor(dataObject) {
      return dataObject.id["$oid"] || dataObject.id;
    },
    inList: true,
    usedToShow: true,
    hideInCreate: true,
    hideInEdit: true
  }, {
    identifier: "name",
    label: "Name",
    accessor: "name",
    type: "string",
    inList: true,
    valuesRejectedOnSubmit: [""]
  }, {
    identifier: "content_type",
    label: "Content Type",
    accessor: "content_type",
    inList: true,
    type: "select",
    dependee: true,
    options: [{
      value: "image",
      label: "Image"
    }, {
      value: "video",
      label: "Video"
    }, {
      value: "pdf",
      label: "Pdf"
    }, {
      value: "media",
      label: "Media"
    }, {
      value: "other",
      label: "Other"
    }],
    required: true
  }, {
    identifier: "file",
    label: "File",
    accessor: "file_url",
    inList: true,
    type: "file",
    required: true,
    hideInEdit: true,
    useGallery: false
  }, {
    identifier: "size",
    label: "Size",
    accessor: function accessor(dataObject) {
      return dataObject.size + " MBs";
    },
    inList: true,
    type: "string",
    required: true,
    hideInCreate: true,
    hideInEdit: true
  }, {
    identifier: "extension",
    label: "Extension",
    accessor: "extension",
    inList: true,
    type: "string",
    required: true,
    hideInCreate: true,
    hideInEdit: true
  }],
  filters: [{
    label: "Content Type",
    name: "content_type",
    type: "select",
    selectConfig: {
      optionsType: "static",
      optionsArray: [{
        value: "image",
        label: "Image"
      }, {
        value: "video",
        label: "Video"
      }, {
        value: "pdf",
        label: "Pdf"
      }]
    }
  }]
};
export { CropImage, DragAndDrop, FileFieldModal, GalleryDocument, GalleryImage, GalleryModal, GalleryVideo, MediaEntry, Media as media, useMedia };